export default function SvgFullScreen2() {
    return (
      <>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9 4H4v5m16 0V4h-5m0 16h5v-5M4 15v5h5"
      ></path>
    </svg>
    </>
    );
  }